import { normalizeKey } from "../formatters/strings.formatter";

/**
 * Sanitiza un valor tipo enum (string union):
 * - normaliza a lower-case
 * - valida contra la whitelist
 * - usa fallback si es inválido
 * - loguea error legible
 */
export function sanitizeEnum<T extends string>(
    value: unknown,
    allowed: readonly T[],
    fallback: T,
    label = 'property'
): T {
    const raw = normalizeKey(value);
    const ok = (allowed as readonly string[]).includes(raw);
    if (!ok) {
        console.error(
            `[mega-menu] Valor inválido para '${label}'="${value}". ` +
            `Valores válidos: ${allowed.join(' | ')}.`
        );
    }
    return (ok ? (raw as T) : fallback);
}